export default {
  name: 'Content section - 3',
  tab: 'content',
  type: 'content-default-section',
  content: {
    title: '',
    introtext: '',
    image: '',
    buttons: '[]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/federica-galli-pF1ug8ysTtY-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '280px',
    'padding-bottom': '280px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '0'
  },
  advanced: {}
}
